import React from 'react';
import { Pill } from '@iwoca/orion';

import { ICellRendererParams } from 'ag-grid-community';

import { Tooltip } from 'components/Tooltip/Tooltip';
import { TProbabilityOfOffer } from 'lendingApi/applications.types';
import styles from './CompanyCell.module.css';

export const CompanyCell = ({ value, data }: ICellRendererParams) => {
  const showPill =
    data.status !== 'declined' &&
    data.status !== 'deferred' &&
    !data.formal_offer_sets?.[0]?.formal_offers?.[0]?.max_amount &&
    data.formal_indicative_offer_sets[0];

  const renderPill = (probability: TProbabilityOfOffer) => {
    switch (probability) {
      case 'high_probability_of_offer':
        return (
          <div className={styles.probabiltyContainer}>
            <Tooltip
              id="high-probability"
              value="80% of comparable applications are approved."
            >
              <Pill variant="green" size="small" className={styles.pill}>
                High chance of approval
              </Pill>
            </Tooltip>
          </div>
        );
      case 'medium_probability_of_offer':
        return (
          <div className={styles.probabiltyContainer}>
            <Tooltip
              id="medium-probability"
              value="50% of comparable applications are approved."
            >
              <Pill variant="yellow" size="small" className={styles.pill}>
                Medium chance of approval
              </Pill>
            </Tooltip>
          </div>
        );
      case 'low_probability_of_offer':
        return (
          <div className={styles.probabiltyContainer}>
            <Tooltip
              id="low-probability"
              value="20% of comparable applications are approved."
            >
              <Pill variant="red" size="small" className={styles.pill}>
                Low chance of approval
              </Pill>
            </Tooltip>
          </div>
        );
      default:
        return '-';
    }
  };

  const companyName =
    value.registered_company_name && value.registered_company_name.trim()
      ? value.registered_company_name
      : '-';

  const companyNumber = value.company_number;

  return (
    <div>
      <div className={styles.companyHeaderText}>{companyName}</div>
      <div className={styles.companyNumber}>{companyNumber}</div>
      {showPill &&
        renderPill(
          data.formal_indicative_offer_sets[0].formal_indicative_offers[0]
            .probability_of_offer,
        )}
    </div>
  );
};
